import { RefreshCw } from "lucide-react";

interface SlowLoadingMessageProps {
  show: boolean;
}

export function SlowLoadingMessage({ show }: SlowLoadingMessageProps) {
  if (!show) return null;

  return (
    <div className="flex items-center justify-center gap-3 p-4 mb-6 rounded-xl bg-white/[0.03] border border-white/[0.06]">
      <RefreshCw className="size-4 text-[#888] animate-spin" />
      <p className="text-sm text-[#888]">
        Fetching your latest generations... This is taking longer than usual,
        please wait.
      </p>
    </div>
  );
}
